<template>
  <v-main class="launcher-main">
    <v-container fluid class="cards-section">
      <v-row align="center" class="launcher" v-if="perfil == PERFILES['ADMINSITRADOR GENERAL']"> </v-row>
      <v-row class="module-grid">
        <v-col cols="12" align="center">
          <div class="text-h6 font-weight-black section-title">Aplicaciones administrativas</div>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card armeria-card" elevation="12" @click="setTheme(1)" hover>
            <div class="card-gradient armeria-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-ammunition</v-icon>
              </div>
              <h3 class="module-title">Armería</h3>
              <p class="module-description">Inventario y control de armamento</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Equipamiento -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card equipamiento-card" elevation="12" @click="setTheme(2)" hover>
            <div class="card-gradient equipamiento-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-briefcase-variant</v-icon>
              </div>
              <h3 class="module-title">Equipamiento</h3>
              <p class="module-description">Control de recursos materiales</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Profesionalización -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card profesionalizacion-card" elevation="12" @click="setTheme(3)" hover>
            <div class="card-gradient profesionalizacion-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-school</v-icon>
              </div>
              <h3 class="module-title">Academia</h3>
              <p class="module-description">Programas de capacitación</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Desarrollo Policial -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card desarrollo-card" elevation="12" @click="setTheme(4)" hover>
            <div class="card-gradient desarrollo-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-account-star</v-icon>
              </div>
              <h3 class="module-title">Certificación policial</h3>
              <p class="module-description">Carrera y evaluación</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Enlace C3 -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card enlacec3-card" elevation="12" @click="setTheme(6)" hover>
            <div class="card-gradient enlacec3-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-radio-tower</v-icon>
              </div>
              <h3 class="module-title">Enlace C3</h3>
              <p class="module-description">Coordinación y comunicaciones</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Recursos Humanos -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card rh-card" elevation="12" @click="setTheme(7)" hover>
            <div class="card-gradient rh-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-account-group</v-icon>
              </div>
              <h3 class="module-title">Recursos Humanos</h3>
              <p class="module-description">Gestión de personal</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Registro Personal -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card personal-card" elevation="12" @click="setTheme(8)" hover>
            <div class="card-gradient personal-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-badge-account</v-icon>
              </div>
              <h3 class="module-title">Registro Personal</h3>
              <p class="module-description">Alta y credencialización</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>

        <!-- Card Consulta Personal -->
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card consulta-card" elevation="12" @click="setTheme(10)" hover>
            <div class="card-gradient consulta-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-magnify</v-icon>
              </div>
              <h3 class="module-title">Consulta Personal</h3>
              <p class="module-description">Búsqueda y expedientes</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4">
          <v-card class="module-card enlace-card" elevation="12" @click="setTheme(9)" hover>
            <div class="card-gradient enlace-gradient"></div>
            <v-card-text class="card-content">
              <div class="icon-wrapper">
                <v-icon size="56" color="white">mdi-city</v-icon>
              </div>
              <h3 class="module-title">Enlace Comisaría</h3>
              <p class="module-description">Operación territorial y novedades</p>
            </v-card-text>
            <div class="card-hover-overlay">
              <v-btn text color="white" large> Acceder <v-icon right>mdi-arrow-right</v-icon> </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { PERFILES } from '@/perfiles.js'

export default {
  mounted() {
    // Redireccionar candidatos a su perfil
    if (this.perfil == 'Candidato') {
      this.$router.push({
        path: '/candidato/informacion_personal/' + this.idPersonal,
        params: { id: this.idPersonal },
      })
    }
    this.DISABLE_LOADER()
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
      idPersonal: 'getIdPersonal',
    }),

    ...mapGetters('tipoItem', {
      tiposItem: 'getTiposItem',
    }),
  },

  methods: {
    ...mapMutations(['DISABLE_LOADER', 'ENABLE_LOADER']),

    async setTheme(theme_id) {
      this.ENABLE_LOADER()

      switch (theme_id) {
        case 1:
          await this.$router.push('/armeria/inventario_de_armas')
          break
        case 2:
          await this.$router.push('/equipamiento/personal')
          break
        case 3:
          await this.$router.push('/profesionalizacion/dashboard')
          break
        case 4:
          await this.$router.push('/desarrollo_profesional/personal')
          break
        case 6:
          await this.$router.push('/enlace_c3/dashboard')
          break
        case 7:
          await this.$router.push('/recursos_humanos/dashboard')
          break
        case 8:
          await this.$router.push('/personal/dashboard')
          break
        case 9:
          await this.$router.push('/enlace/pase_lista')
          break
        case 10:
          await this.$router.push('/consulta_personal/personal')
          break
      }
    },
  },

  data() {
    return {
      PERFILES,
    }
  },
}
</script>

<style scoped>
/* ===========================
   MAIN LAYOUT - Fondo oscuro fijo
   =========================== */
.launcher-main {
  background: linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%);
  min-height: 100vh;
  overflow-x: hidden;
}

/* ===========================
   HERO SECTION
   =========================== */
.hero-section {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  padding: 60px 0 40px 0;
  position: relative;
  overflow: hidden;
}

/* Efectos de luz sutil con radial-gradient */
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 20% 50%, rgba(108, 92, 231, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(255, 159, 67, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-title {
  text-align: center;
  animation: fadeInUp 0.8s ease-out;
}

.hero-logo {
  width: 90px;
  height: 90px;
  object-fit: contain;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.5));
  transition: transform 0.3s ease;
}

.hero-logo:hover {
  transform: scale(1.05);
}

/* ===========================
   CARDS SECTION
   =========================== */
.cards-section {
  padding: 60px 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.module-grid {
  justify-content: flex-start;
}

.section-title {
  color: #e6e6e6;
}

/* ===========================
   MODULE CARDS - Diseño Moderno con Glass-morphism
   =========================== */
.module-card {
  position: relative;
  height: 280px;
  border-radius: 20px !important;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  background: #1e1e1e !important;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

/* Overlay oscuro sobre el gradiente */
.module-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.8) 100%);
  z-index: 1;
  transition: opacity 0.3s ease;
}

/* Efectos hover con elevación y escala */
.module-card:hover {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.2);
}

.module-card:hover::before {
  opacity: 0.6;
}

/* ===========================
   GRADIENTES DE FONDO POR MÓDULO
   =========================== */
.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.armeria-gradient {
  background: linear-gradient(135deg, #1e1e2e 0%, #6c5ce7 100%);
}

.equipamiento-gradient {
  background: linear-gradient(135deg, #2e2416 0%, #ff9f43 100%);
}

.profesionalizacion-gradient {
  background: linear-gradient(135deg, #1a2e24 0%, #00d2a0 100%);
}

.desarrollo-gradient {
  background: linear-gradient(135deg, #2e2416 0%, #ffa502 100%);
}

.enlacec3-gradient {
  background: linear-gradient(135deg, #2e2416 0%, #ffa502 100%);
}

.rh-gradient {
  background: linear-gradient(135deg, #2e1a1a 0%, #ee5a6f 100%);
}

.personal-gradient {
  background: linear-gradient(135deg, #2a1816 0%, #c23616 100%);
}

.consulta-gradient {
  background: linear-gradient(135deg, #1a2e1a 0%, #26de81 100%);
}

.enlace-gradient {
  background: linear-gradient(135deg, #1a2a2e 0%, #45aaf2 100%);
}

/* ===========================
   CARD CONTENT
   =========================== */
.card-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 30px 20px !important;
  text-align: center;
}

/* Icono dentro de círculo con glass-morphism */
.icon-wrapper {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 50%;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.module-card:hover .icon-wrapper {
  transform: scale(1.1) rotate(5deg);
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.4);
}

/* Título del módulo */
.module-title {
  color: #ffffff !important;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  letter-spacing: 0.5px;
}

/* Descripción del módulo */
.module-description {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.4;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

/* ===========================
   HOVER OVERLAY CON BOTÓN
   =========================== */
.card-hover-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
  z-index: 3;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
}

.module-card:hover .card-hover-overlay {
  opacity: 1;
  transform: translateY(0);
}

/* ===========================
   ANIMATIONS
   =========================== */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===========================
   RESPONSIVE DESIGN
   =========================== */
@media (max-width: 960px) {
  .hero-section {
    padding: 40px 0 30px 0;
  }

  .hero-title h1 {
    font-size: 2rem !important;
  }

  .module-card {
    height: 260px;
  }

  .cards-section {
    padding: 40px 15px;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 30px 0 20px 0;
  }

  .hero-title h1 {
    font-size: 1.5rem !important;
  }

  .hero-title .v-icon {
    font-size: 48px !important;
  }

  .module-card {
    height: 240px;
  }

  .icon-wrapper {
    width: 80px;
    height: 80px;
  }

  .icon-wrapper .v-icon {
    font-size: 40px !important;
  }

  .module-title {
    font-size: 1.2rem;
  }

  .module-description {
    font-size: 0.85rem;
  }

  .cards-section {
    padding: 30px 10px;
  }
}

/* ===========================
   SCROLLBAR PERSONALIZADA
   =========================== */
.launcher-main::-webkit-scrollbar {
  width: 8px;
}

.launcher-main::-webkit-scrollbar-track {
  background: #0a0a0a;
}

.launcher-main::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

.launcher-main::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Scroll suave */
html {
  scroll-behavior: smooth;
}
</style>
